/**
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';
import AppService from '@/services/app';
import Store from '@/store/store';

export default {
  // Hit the login route and get the users details
  login(params: { username: string; password: string }) {
    return Api().post('/auth/login', params).then((response) => {
      // no need to handle failed login as go will return 401 - caught by api.ts

      // send the logged in user data to the store      
      Store.dispatch('users/setLoggedInUser', {
        loggedInUser: {
          loggedIn: true,
          displayName: response.data.displayName,
        },
      });         
  
      return response;
    });
  },

  // Hit the check route and get the users details
  checkAuth() {
    return Api().get('/auth/me').then((response) => {
      // no need to handle failed login as go will return 401 - caught by api.ts

      // send the logged in user data to the store      
      Store.dispatch('users/setLoggedInUser', {
        loggedInUser: {
          loggedIn: true,
          displayName: response.data.displayName,
        },
      });      
  
      return response;
    });  
  },

  logout() {
    // empty the store
    Store.dispatch('app/reset');
    Store.dispatch('campaigns/reset');
    Store.dispatch('users/reset');
    
    Api().post('/auth/logout').then((response) => {
      // redirect the user back to auth
      AppService.successHandler(response.data.message);
      window.location.href = Store.getters['app/urls'].login;
    });  
  },

};
